<template>
  <div v-if="unseenVisitorCount" class="pill__circle visitors-pulse-animation">
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'UnseenVisitorCountComponent',
  components: {},

  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      unseenVisitorCount: 'getUserUnseenVisitorCount',
    }),
  },
  methods: {},
  watch: {},
  mounted() {
  }
};
</script>
